"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperationListExplained = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const OperationExplainedBox_1 = require("./OperationExplainedBox");
const RawQuery_1 = require("./RawQuery");
function OperationListExplained({ query, queryModeller, stepNumber, language, onMouseEnter, onMouseLeave, }) {
    return (react_1.default.createElement(react_1.default.Fragment, null, query.operations.map((op, index) => {
        var _a;
        const def = queryModeller.getOperationDefinition(op.id);
        if (!def) {
            return `Operation ${op.id} not found`;
        }
        const title = def.renderer(op, def, queryModeller.innerQueryPlaceholder);
        const body = def.explainHandler ? def.explainHandler(op, def) : (_a = def.documentation) !== null && _a !== void 0 ? _a : 'no docs';
        return (react_1.default.createElement("div", { key: index, onMouseEnter: () => onMouseEnter === null || onMouseEnter === void 0 ? void 0 : onMouseEnter(op, index), onMouseLeave: () => onMouseLeave === null || onMouseLeave === void 0 ? void 0 : onMouseLeave(op, index) },
            react_1.default.createElement(OperationExplainedBox_1.OperationExplainedBox, { stepNumber: index + stepNumber, title: react_1.default.createElement(RawQuery_1.RawQuery, { query: title, language: language }), markdown: body })));
    })));
}
exports.OperationListExplained = OperationListExplained;
//# sourceMappingURL=OperationListExplained.js.map